export default __webpack_public_path__ + "static/media/viandehachee.71e4f394.jpg";